import memberIndex from '@/pages/member/index.vue'
import memberClass from '@/pages/member/memberClass.vue'
import memberList from '@/pages/member/memberList.vue'
import memberDetail from '@/pages/member/memberDetail.vue'

const appRoutes = [{
	path: '/member',
	redirect: '/member/memberClass',
	component: memberIndex,
	children: [{
			path: 'memberClass',
			name: 'memberClass',
			component: memberClass
		},
		{
			path: 'memberList',
			name: 'memberList',
			component: memberList
		},
		{
			path: 'memberDetail',
			name: 'memberDetail',
			component: memberDetail
		}]
}]
export default appRoutes
